import React, { useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';


function Detail(props) {

    const { licensePlate, feeDetails, convertedPlate, data, message, handlePayment } = props
    const baht = (n) =>
        Number(n || 0).toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    // ยอดที่โชว์เป็นยอดหลังหักส่วนลดแล้ว ถ้าไม่บอกว่าหักไปเท่าไหร่
    // คนขับเห็นแค่ตัวเลขสุดท้าย เทียบกับอัตราค่าจอดเองไม่ได้ว่าถูกหรือผิด
    const hasDiscount = Number(feeDetails?.discount) > 0;
    // ยอดสุทธิถูกปัดขึ้นเป็นขั้นต่ำเมื่อไหร่ ค่าบริการลบส่วนลดจะไม่เท่ากับยอดที่ต้องจ่าย
    // กรณีนั้นต้องบอกไว้ ไม่ใช่โชว์เลขสามตัวที่บวกลบกันไม่ลงตัว
    const minCharged =
        hasDiscount &&
        Number(feeDetails?.summ || 0) >
        Math.max(0, Number(feeDetails?.total_fee || 0) - Number(feeDetails?.discount || 0)) + 0.01;
    return (
        <>
            <div className={`card-body pt-5 ${!feeDetails ? 'd-none' : ''}`} >
                <h4 className="card-title text-center" id="plate_d">หมายเลขทะเบียน: <span id="plate">{convertedPlate ?? "ไม่สามารถระบุได้"}</span></h4>
                <div className="container p-3">
                    <div className="row">
                        <div className="col-5">
                            ประตูเข้า
                        </div>
                        <div className="col-7" id="gate_in">
                            <p>ทางเข้าหลัก</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            ประเภทรถ
                        </div>
                        <div className="col-7">
                            <p>รถยนต์</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            วันเวลาเข้า
                        </div>
                        <div className="col-7">
                            <p id="datetime_in">{feeDetails?.datetime_in}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            วันเวลาปัจจุบัน
                        </div>
                        <div className="col-7">
                            <p id="datetime_now">{feeDetails?.datetime_now}</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            เวลาจอด
                        </div>
                        <div className="col-7">
                            <p><span id="hour">{feeDetails?.difftime_h}</span> ชั่วโมง <span id="min">{feeDetails?.difftime_m}</span> นาที</p>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-5">
                            สิทธิ์จอดฟรี
                        </div>
                        <div className="col-7">
                            {/* <p>
                                    <span id="hour_free">{feeDetails?.freeH ? `${feeDetails?.freeH} ชั่วโมง` : ""} </span>
                                    <span id="hour_free">{feeDetails?.freeM ? `${feeDetails?.fee_m} นาที` : ""}</span>
                                    <span id="hour_free">{(!feeDetails?.freeM && !feeDetails?.freeM) ? "0 นาที" : ""}</span>
                                </p> */}
                            {data?.is_estamp === 1 ? (
                                <p>ฟรีค่าจอดรถ (e-Stamp)</p>
                            ) : (
                                <p><span id="hour_free">{feeDetails?.starter_free_minute} นาที</span></p>
                            )}
                        </div>
                    </div>
                    {data?.is_estamp === 0 && (
                        <div className="row">
                            <div className="col-5">
                                เวลาคิดค่าบริการ
                            </div>
                            <div className="col-7">
                                <p><span id="hour_fee">{feeDetails?.fee_h}</span> ชั่วโมง <span id="min_fee">{feeDetails?.fee_m}</span> นาที</p>
                                <p>(คิดเป็น <span id="hour_cal">{feeDetails?.difftime_h_cal}</span> ชั่วโมง)</p>
                            </div>
                        </div>
                    )}
                    {hasDiscount && (
                        <div className="row">
                            <div className="col-5">
                                ค่าบริการ
                            </div>
                            <div className="col-7">
                                <p><span id="total_fee">{baht(feeDetails?.total_fee)} บาท</span></p>
                            </div>
                        </div>
                    )}
                    {hasDiscount && (
                        <div className="row">
                            <div className="col-5">
                                ส่วนลด{feeDetails?.discount_code ? ` (${feeDetails.discount_code})` : ""}
                            </div>
                            <div className="col-7">
                                <p className="text-success"><span id="discount">-{baht(feeDetails?.discount)} บาท</span></p>
                            </div>
                        </div>
                    )}
                    {feeDetails?.paid > 0 && !!feeDetails?.requirePayment && (<div className="row">
                        <div className="col-5">
                            จ่ายแล้ว
                        </div>
                        <div className="col-7">
                            <p><span id="hour_free">{feeDetails?.paid?.toLocaleString("en-US", {
                                // style: 'currency',
                                currency: "USD",
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })} บาท</span></p>
                        </div>
                    </div>)}

                </div>
                <div id="parking_fee" className={feeDetails?.summ > 0 ? '' : 'd-none'}>
                    <h5 className={`text-center ${!feeDetails?.requirePayment ? "text-success" : "text-primary"}`}>{feeDetails?.paid > 0 && !!feeDetails?.requirePayment ? "ส่วนต่างค่าบริการที่ต้องชำระ" : (feeDetails?.paid > 0 && !feeDetails?.requirePayment ? "ชำระค่าบริการแล้ว" : "ค่าบริการที่ต้องชำระ")}</h5>
                    <h5 className={`text-center ${!feeDetails?.requirePayment ? "text-success" : "text-primary"}`}><span id="amount">{(!feeDetails?.requirePayment ? feeDetails?.summ : (feeDetails?.summ - feeDetails?.paid))?.toLocaleString("en-US", {
                        // style: 'currency',
                        currency: "USD",
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}</span> บาท</h5>
                    {minCharged && (
                        <p className="text-center text-muted" style={{ fontSize: 'small' }}>
                            คิดขั้นต่ำ {baht(feeDetails?.min_payment_amount)} บาท
                        </p>
                    )}
                    {feeDetails?.summ > 0 && !!feeDetails?.requirePayment && (
                        <div className="d-grid gap-2 p-3" onClick={handlePayment}>
                            <button className="btn btn-primary" type="button">ชำระเงิน</button>
                        </div>
                    )}

                </div>
                <div id="free_charge" className={feeDetails?.summ > 0 ? 'd-none' : ''}>
                    <h5 className="text-center">ไม่มีค่าบริการ</h5>
                </div>
                <p className="text-center pt-4" style={{ fontSize: 'small' }}><Link to="/condition">เงื่อนไขการให้บริการ</Link></p>
            </div>
            <div className={`${(licensePlate && !feeDetails && message) ? '' : 'd-none'}`} id="free_charge" >
                <h4 className="text-center  text-secondary py-5">{message}</h4>
            </div>


        </>
    )
}

export default Detail;